import axiosFetch from './config';

export const getTransactions = async (currencyId, page) => {
    let token = await localStorage.getItem('token')
    return axiosFetch({
        method: "GET",
        url: `/transactions?currencyId=${currencyId}&page=${page}`,
        headers: {
            Authorization: 'Bearer ' + token,
        },
    })
}

export const getTransactionsById = async (id) => {
    let token = await localStorage.getItem('token')
    return axiosFetch({
        method: "GET",
        url: `/transactions/${id}`,
        headers: {
            Authorization: 'Bearer ' + token,
        },
    })
}